import React, { Component } from 'react'
import { Router, Redirect } from '@reach/router'
import { Home } from './components/pages'
import Seeyodoc from './components/pages/seeyoudoc'
import Aims from './components/pages/aims'
import Eo from './components/pages/eo'
import Nac from './components/pages/nac'
import CaseEvict from './components/pages/caseevict'
import Drapshop from './components/pages/drapshop'

export default class Routes extends Component{
  render() {
    return (
        <Router>
          <Home path="/" />
          <Works path="works">
            <Seeyodoc path="/seeyoudoc" />
            <Aims path="/aims" />
            <Eo path="/eo-ph" />
            <Nac path="/nac-cmc-omt" />
            <CaseEvict path="/case-evict" />
            <Drapshop path="/drapshop" />
          </Works>
          <Redirect from="/home" to="/" noThrow />
        </Router>
        )
    }
}

const Works = (props) => {
  return props.children
}

